export const SME_HOURS_PERCENT: readonly number[] = [50, 60, 70, 80, 90, 100];
export const DISCUSSION_MESSAGE_INPUT_MAX_LENGTH = 30000;